import React from "react";
import ceoPhoto from "../../assets/img/ceo_photo.png";
import ceoName from "../../assets/img/CEO_NAME.png";

const MobileCEOMessage = () => {
  return (
    <div className="m_company_wrap">
      <div className="company_tit">
        <h3>CEO 인사말</h3>
        <p>Ceo Message</p>
      </div>
      <div className="company_cot">
        <h4 className="mtit">CEO 인사말</h4>
        <dl className="m_ceo_bou">
          <dt>
            <img src={ceoPhoto} alt="ceo_photo" />
          </dt>
          <dd>
                <strong>
                  "대한민국 금거래의 중심!" 한국금거래소
                </strong>
                <p className="mb30">
                2005년 설립한 한국금거래소는 시스템 기반의 투명한 업무 프로세스 구축, 
                동기부여를 통한 조직문화 확립, 다양한 판매채널을 통한 안정적 수익 창출, IT 기술 기반  
                미래 신성장 동력 발굴 등을 통해 지속 발전하여 명실상부 대한민국 최고의 귀금속 기업으로  
                자리매김하였습니다. 
                <br />
                <br />
                오늘이 있기까지 고객 여러분의 아낌없는 관심과 애정이 성장 원동력이라는 사실을  
                잊지 않고 지속적인 “고객 만족 실현”을 최우선 과제로 삼아 “정도경영(正道經營)”에  
                매진하겠습니다. 
                </p>
                <br />
                <p>
                  <strong>
                    ‘Create Value beyond Gold’
                    <br />
                    한국금거래소는 미래를 위한 새로운 가치 창출에 도전합니다!
                  </strong>
                  골드바로 시작해 실버바와 플래티넘바, 각종 순금 제품과 패션 주얼리, 실물 교환형 유가증권,  
                  금 자판기 등 “전국 가맹점”을 통해 고객의 Needs를 충족시켜 온 한국금거래소는 새로운 도전을 
                  시작합니다.
                  <br />
                  <br />
                  세계 각국은 기후변화로 인한 글로벌 위기 대응 차원 ESG 경영을 통해 글로벌 정책에 부합하는  
                  활동을 전개 중으로 도시광산 자원 재생을 목적으로 설립한 “한국금거래소FTC”는 미국의 친환경  
                  자원재활용 인증인 “UL2809”를 획득, 재활용 금의 고순도화 정련으로 탄소 배출(광물 제련금 1Kg  
                  생산 대비 1/1000) 저감에 기여, 글로벌 친환경 정책의 준수를 통해 글로벌 Major 기업과 상생  
                  협업의 교두보를 마련하였습니다. 
                  <br />
                  <br />
                  한국금거래소는 최상의 운영체제 확립과 변화 지향적이고 유연한 기업문화 정착을 바탕으로  
                  귀금속 산업에서의 친환경・자원 선순환 대표 기업으로 거듭나“금 그 이상의 가치 창출 
                  (Create Value beyond Gold)”을 완성하여 해외에서도 인정받는 초일류 글로벌 “한국금거래소”로  
                  발전해 나가겠습니다.
                  <br />
                  <br />
                  그동안 아낌없이 응원해 주신 고객 여러분의 깊은 사랑을 자양분 삼아 새로운 혁신을 주도하여  
                  대한민국의 자랑이 되겠습니다. 감사합니다!
                  <br />
                  <br />
                </p>
                <img width="354" height="75" src={ceoName} alt="ceo_name" />
                {/* <!--<h4 className="ceo_name">대표이사 송종길</h4>--> */}
          </dd>
        </dl>
      </div>
    </div>
  );
};

export default MobileCEOMessage;
